import controller from './service-accounts.controller';

const template = require('./service-accounts.html');

export default {
    controller,
    template
};
